import * as React from 'react';
import { IStyleSet, Label, ILabelStyles, Pivot, PivotItem, DefaultButton, Stack, CommandBarButton, Separator, IStackStyles } from '@fluentui/react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/Hooks';
import { useTranslation } from 'react-i18next';
import { Int32Value } from 'google-protobuf/google/protobuf/wrappers_pb';
import { ApiMessage, API_URL, clearSession, getHeaders, getSession, ORGANIZATION_LOGO_URL, STORAGE_URL } from '../../../app/Api';
import { GetOrganizationRequest, GetOrganizationResponse } from '../../../repository/UserManagement/organization_pb';
import { getOrganization, setOrganization } from './../Master/MasterLayoutSlice';
import { addOrderBookItem, cancelOrder, dismissMessage, getCurrencyPairs, getItems, getOrdersBook, reset, resetCurrencyPairs, resetOrderBook, resetSet, setIsFilteredCurrencyPairsSet, setIsFilteredOrderBookSet, setIsFilteredSet, setNumberOfResults, setSearchText, setSelectedCurrencyPairItems, setSelectedItems, setSelectedOrderBookItems, setSort, updateOrderBookItem } from './../Trading/TradingLayoutSlice';

import { OrdersPage } from './../../pages/Trading/Orders/OrdersPage';
import { TradesPage } from './../../pages/Trading/Trades/TradesPage';

import { getCurrentOrganization, normalizeKey, setCurrentOrganization } from '../../../app/Helpers';
import { navHeaderStyle } from '../../common/NavHeader/NavHeader.styles';
import BinanceOrderBook, { DepthSnapshot, OrderBookEntry, OrderBookHandle } from '../../common/OrderBook/OrderBook';
import { useEffect, useRef, useState } from 'react';
import { AdvancedChartPage } from '../../pages/Trading/AdvancedChart/AdvancedChartPage';
import { PlaceOrderForm } from '../../forms/Trading/Orders/PlaceOrder/PlaceOrderForm';
import { FormType } from '../../forms/FormProps';
import { TableState } from '../../common/Table/TableSate';
import { GetOrderBookRequest } from '../../../repository/Trading/order_pb';
import { OrderAction } from '../../../app/Enums';
import { getFeedConnection, terminateFeedConnection } from '../../../app/Singler';
const labelStyles: Partial<IStyleSet<ILabelStyles>> = {
    root: { marginTop: 10 },
};
//let req = new GetOrganizationRequest();
//let getOrganizationPromise: any;
let org: number = -1;
let promise: any;
let getItemsPromise: any;


let req: GetOrderBookRequest;

export const TradingLayout: React.FunctionComponent = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const state: {
        organization: any,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        set: TableState,
        orderBook: TableState,

    } = useAppSelector((state) => {
        return {
            organization: state.masterLayout.currentOrganization, message: state.masterLayout.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            set: state.advancedChartPage.set,
            orderBook: state.tradingLayout.orderBook

        }
    })
    const [selectedKey, setSelectedKey] = useState("1");
    const getTabId = (itemKey: string) => {
        return `ShapePivot_${itemKey}`;
    };
    const handleLinkClick = (item?: PivotItem) => {
        if (item) {
            setSelectedKey(item.props.itemKey!);
        }
    };
    const bookRef = useRef<OrderBookHandle>(null);

    // When you receive depth data (WebSocket, REST, etc.)
    const onDepth = (snapshot: DepthSnapshot) => {

        bookRef.current?.update(snapshot);
    };



    useEffect(() => {

        let current = getSession();

        if (!current) {
            clearSession();
            navigate("/login");

        }

        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                if (state.organization == undefined || state.organization.id != org) {
                    let getOrgReq = new GetOrganizationRequest()
                    getOrgReq.setId(org)
                    promise?.abort()
                    promise = dispatch(getOrganization({ body: getOrgReq, headers: getHeaders() }))
                    promise.unwrap().catch((e: any) => {
                        window.location.href = "/";
                    })
                }
            }
        } else {
            if (state.organization == undefined && current.organization?.id) {

                let getOrgReq = new GetOrganizationRequest()
                getOrgReq.setId(current.organization?.id)
                promise?.abort()
                promise = dispatch(getOrganization({ body: getOrgReq, headers: getHeaders() }))
            }
            org = -1;
        }







        return () => { //clean up
            dispatch(reset())
            promise?.abort();
            org = -1;
        }
    }, [])




    return (
        <Stack>
            <Stack horizontal>

                <Stack.Item grow>
                    <Pivot
                        headersOnly={true}
                        selectedKey={selectedKey}
                        onLinkClick={handleLinkClick}
                        getTabId={getTabId}

                    >
                        <PivotItem
                            itemKey={"1"}
                            headerText={t("trading")}
                            style={{ alignSelf: 'flex-end' }}

                            headerButtonProps={{
                                'data-order': 1,

                                'data-title': 'My Files Title',
                            }}
                        >

                        </PivotItem>
                        <PivotItem itemKey={"2"}
                            headerText={t("orders")}
                        >

                            <OrdersPage ></OrdersPage>
                        </PivotItem>
                        <PivotItem itemKey={"3"}
                            headerText={t("trades")}>
                            <TradesPage ></TradesPage>

                        </PivotItem>

                    </Pivot>
                </Stack.Item>
                <CommandBarButton
                    iconProps={{ iconName: 'Home' }}
                    text={t("dashboard")}
                    onClick={() => {
                        navigate("/" + ((org == -1) ? "" : "?org=" + org));

                    }}
                // Set split=true to render a SplitButton instead of a regular button with a menu
                // split={true}
                />
            </Stack >


            <Stack style={{ display: selectedKey === "1" ? 'flex' : 'none', flex: 1 }}>
                <TradingTab></TradingTab>
            </Stack> :

            <Stack style={{ display: selectedKey === "2" ? 'flex' : 'none', flex: 1 }}>
                <OrdersPage   ></OrdersPage>
            </Stack>

            <Stack style={{ display: selectedKey === "3" ? 'flex' : 'none', flex: 1 }}>
                <TradesPage ></TradesPage>
            </Stack>




        </Stack>
    );
};

export const TradingTab: React.FunctionComponent = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const state: {
        organization: any,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        set: TableState,
        orderBook: TableState,
    } = useAppSelector((state) => {
        return {
            organization: state.masterLayout.currentOrganization, message: state.masterLayout.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            set: state.advancedChartPage.set,
            orderBook: state.tradingLayout.orderBook

        }
    })
    const bookRef = useRef<OrderBookHandle>(null);

    function generateRandomData(count: number): { price: number; amount: number; total: number }[] {
        const data: { price: number; amount: number, total: number }[] = [];
        let basePrice = 7.2;

        for (let i = 0; i < count; i++) {
            // Slightly randomize price up/down
            const price = +(basePrice + Math.random() * 0.3).toFixed(3);
            // Random quantity between 1 and 25
            const amount = Math.floor(Math.random() * 25) + 1;

            const total = price * amount;

            data.push({ price, amount, total });

            // Optional: bias the price upward slightly for variety
            basePrice += Math.random() * 0.01;
        }

        return data;
    }

    // Example usage:


    // When you receive depth data (WebSocket, REST, etc.)


    useEffect(() => {
        let myInterval: any = undefined;
        req = new GetOrderBookRequest();
        if (myInterval != undefined) {
            clearInterval(myInterval);
        }
        myInterval = setInterval(async () => {

            getItemsPromise = dispatch(getOrdersBook({ body: req, headers: getHeaders() }))

        }, 60 * 1000);
        return () => { //clean up
            getItemsPromise?.abort()
            clearInterval(myInterval);
            terminateFeedConnection()

        }
    }, [])

    const pageSectionStyle: Partial<IStackStyles> = {
        root: {
            boxSizing: 'border-box',
            border: '1px solid #eee',
            overflow: "auto",
            height: "95vh", // or maxHeight


        },
    };


    useEffect(() => {
        if (state.set.selected?.length > 0) {
            if (bookRef.current?.getPair()?.id != state.set.selected.at(0).id) {
                bookRef.current?.init(state.set.selected.at(0))
                bookRef.current?.update({
                    bids: [],
                    asks: [],
                    lastPrice: state.set.selected.at(0).tradingPrice,

                });
                req.setCurrencypair(state.set.selected?.at(0)?.id)
                req.setTop(30)
                getItemsPromise = dispatch(getOrdersBook({ body: req, headers: getHeaders() }))
                if (org == -1)
                    setSearchParams({ symbol: state.set.selected?.at(0)?.id });
                else
                    setSearchParams({ symbol: state.set.selected?.at(0)?.id, org: "" + org });

            } else {
                bookRef.current?.setPrice(state.set.selected.at(0).tradingPrice)
            }
        }
    }, [state.set.selected])

    useEffect(() => {
        if (state.set.selected?.at(0) == undefined) {
            return;
        }
        if (state.orderBook.items?.length > 0) {
            let buy = state.orderBook.items.filter(e => e.tradeAction == OrderAction.BUY);
            let sell = state.orderBook.items.filter(e => e.tradeAction == OrderAction.SELL)
            bookRef.current?.init(state.set.selected.at(0))

            bookRef.current?.update({
                bids: buy,
                asks: sell,
                lastPrice: state.set.selected.at(0).tradingPrice,
            });

        } else {
            bookRef.current?.clear();
        }
        var connection = getFeedConnection()

        if (connection != null) {
            connection.then(e => {
                if (e) {
                    e.off("ORDER_" + state.set.selected?.at(0)?.id + ""); // clean old
                    e.on("ORDER_" + state.set.selected?.at(0)?.id + "", (message: any) => {
                        try {
                  
                            if (state.orderBook.isFetching) {
                                return;
                            }
                            var val = JSON.parse(message)
                            //Object { Action: 1, Id: "688fcf86061beb25cb43116b", TradeAction: 2, Price: 7.41, Total: 741, Quantity: 100, CurrencyPair: "683b626e4413b67bc759224b" }
                            if (val.Action == 1) {
                                bookRef.current?.add(val.TradeAction, {
                                    amount: val.Quantity,
                                    price: val.Price,
                                    total: val.Total,
                                });
                            } else if (val.Action == 2) {
                                bookRef.current?.remove(val.TradeAction, {
                                    amount: val.Quantity,
                                    price: val.Price,
                                    total: val.Total,
                                });
                            }
                        } catch { }
                        //{"isTrade":1,"currencyPair":"6840b902c13dcaa9977c9dc5","TradingPrice":7.245,"SellPrice":7.11,"BuyPrice":7.22,"VolumeBase":0.0,"VolumeQuote":0.0,"CreatedDate":"2025-07-27T19:28:55.8737168Z"}
                    });
                }
            })
        }
    }, [state.orderBook.items])

    return (
        <Stack horizontal>
            < Stack styles={pageSectionStyle} >
                <Stack.Item >
                    <BinanceOrderBook ref={bookRef} />
                </Stack.Item>
                <Stack.Item>
                    <Separator alignContent="start"><b>{t("placeOrder")}</b></Separator>
                </Stack.Item>
                <Stack.Item align='end'>
                    {state.set && state.set.selected != undefined && state.set.selected?.length > 0 ? <PlaceOrderForm childrenGap={10} padding={30} renderObject={{ currencyPair: state.set.selected.at(0), isTradingView: true }} type={FormType.ADD} onSuccess={(e) => {

                    }} onCancel={() => { }} /> : undefined}
                </Stack.Item>

            </Stack >
            <Stack.Item grow>
                <AdvancedChartPage maintainState={true} />

            </Stack.Item>

        </Stack >
    );
};
